// Campus photo for /colleges/pennsylvania-state-university: CC BY-SA 3.0, by Nathaniel C. Sheetz, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AOld_Main_Snow_PSU.JPG), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/pennsylvania-state-university/; credited under the photo.
const photo = {
    "slug": "pennsylvania-state-university",
    "alt": "Old Main in winter at Penn State's University Park campus",
    "src": "/colleges/pennsylvania-state-university/campus-1600.webp",
    "srcSmall": "/colleges/pennsylvania-state-university/campus-800.webp",
    "srcMid": "/colleges/pennsylvania-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/pennsylvania-state-university/og.jpg",
    "title": "Old Main Snow PSU",
    "author": "Nathaniel C. Sheetz",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AOld_Main_Snow_PSU.JPG",
    "read": "2026-09-30"
};

export default photo;
